import * as React from 'react';
import { Link, useLocation } from 'react-router-dom';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import HomeRoundedIcon from '@mui/icons-material/Dashboard';
import DownloadIcon from '@mui/icons-material/Download';
import DeveloperIcon from '@mui/icons-material/Code';
import Group from '@mui/icons-material/Group';
import BarChart from '@mui/icons-material/BarChart';
import GolfCourse from '@mui/icons-material/GolfCourse';
import SportsGolfIcon from '@mui/icons-material/SportsGolf';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import Downloads from '../pages/account/Downloads';
import FuseIcon from './FuseIcon';
import { useAuth } from '../AuthContext';

const mainListItems = [
  { text: 'Dashboard', icon: <HomeRoundedIcon />, route: '/account' },
  // { text: 'Rounds', icon: <GolfCourse />, route: '/account/rounds' },
  // { text: 'Shot Data', icon: <BarChart />, route: '/account/shot-data' },
  { text: 'Web Simulator', icon: <FuseIcon />, route: '/account/simulator' },
  // { text: 'Players', icon: <Group />, route: '/account/players' },
  // { text: 'Downloads', icon: <DownloadIcon />, route: '/account/downloads' },
  { text: 'Course Developer', icon: <DeveloperIcon />, route: '/account/developer', requiresDeveloperFlag: true },
];

const secondaryListItems = [
  // { text: 'Billing', icon: <CreditCardIcon />, route: '/account/billing' },
  { text: 'Settings', icon: <SettingsRoundedIcon />, route: '/account/profile' },
  { text: 'Support', icon: <HelpRoundedIcon />, link: 'https://help.opengolfsim.com' }
];

export default function MenuContent(props) {
  const location = useLocation();
  const { user } = useAuth();
  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'space-between' }}>
      <List dense>
        {mainListItems
          .filter(item => !item.requiresDeveloperFlag || (item.requiresDeveloperFlag && user.isDeveloper))
          .map((item, index) => (
            <ListItem key={index} disablePadding sx={{ display: 'block' }}>
              <ListItemButton
                selected={location.pathname === item.route}
                {...item.route && {
                  to: item.route,
                  component: Link,
                  ...props.onClick && { onClick: props.onClick },
                }}
                {...item.link && {
                  onClick: () => {
                    window.open(item.link);
                    if (props.onClick) {
                      props.onClick();
                    }
                  }
                }}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            </ListItem>
          ))}
      </List>
      <List dense>
        {secondaryListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              selected={location.pathname === item.route}
              {...item.route && {
                to: item.route, component: Link,
                ...props.onClick && { onClick: props.onClick },
              }}
              {...item.link && {
                onClick: () => {
                  window.open(item.link);
                  if (props.onClick) {
                    props.onClick();
                  }
                }
              }}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Stack>
  );
}